// extracted by mini-css-extract-plugin
module.exports = {"container":"TextUnread_container__2Uycn","unread":"TextUnread_unread__sPMUQ","ellipse":"TextUnread_ellipse__3jc9o","questionMark":"TextUnread_questionMark__1ZgW-"};